$(document).ready(function(){

	// Price Conversions
	if($('.product').length > 0){

		var base_price=$('.base_price').html(),
			convertCDN=Math.round(Currency.convert(parseInt(base_price),"USD","CAD")), 
			convertEUR=Math.round(Currency.convert(parseInt(base_price),"USD","EUR")),
			convertGBP=Math.round(Currency.convert(parseInt(base_price),"USD","GBP")),
			convertYEN=Math.round(Currency.convert(parseInt(base_price),"USD","JPY")); 
		$('.sub-price').html(
			'CDN$'+convertCDN+' | '+
			'&euro;'+convertEUR+' | '+
			'&pound;'+convertGBP+' | '+
			'&yen;'+convertYEN
		);

	}

	// Notice text
	$.ajax({
		url: 'http://publishbrand.com?json_request=1&callback=?',
		dataType: 'json',
		success: function(result){
		
			$('.noteice_text').text(result.notice_field.title);

			$('.sticky .nav').append('<li class="mn"><h6>Account</h6></li>');
			$.each(result.footer_account, function(key, value){
				$('.top-footer ul').eq(0).append('<li><a href="'+value.url+'">'+value.title+'</a></li>');
				$('.sticky .nav').append('<li class="mn"><a href="'+value.url+'">'+value.title+'</a></li>');
			});

			$('.sticky .nav').append('<li class="mn"><h6>Service</h6></li>');
			$.each(result.footer_service, function(key, value){
				$('.top-footer ul').eq(1).append('<li><a href="'+value.url+'">'+value.title+'</a></li>');
				$('.sticky .nav').append('<li class="mn"><a href="'+value.url+'">'+value.title+'</a></li>');
			});

			$('.sticky .nav').append('<li class="mn"><h6>Company</h6></li>');
			$.each(result.footer_company, function(key, value){
				$('.top-footer ul').eq(2).append('<li><a href="'+value.url+'">'+value.title+'</a></li>');
				$('.sticky .nav').append('<li class="mn"><a href="'+value.url+'">'+value.title+'</a></li>');
			});
          	
		}
	});

});